export default __webpack_public_path__ + "static/media/darkgradation.6fee7d48.webp";